// src/services/CriticalOperationService.js
import { apiGet, apiPostForm, apiPostFormRoot, apiGetRoot } from "./axiosHelper";
import { BASE_URL } from "./BaseUrl";

const CriticalOperationService = {
  // ✅ get_devices (some units want GET, some want POST)
  // Use GET first (based on your Postman "Only GET allowed")
  getDevices: async () => 
    apiPostForm("/get_devices", {}),

  // Time History
  getOperationsFilter: (from_date, to_date, device_id = "") =>
    apiPostForm("/get_operations_filter", { from_date, to_date, device_id }),

  // ✅ Garments Production -> apiv6
  // ✅ apiv6 + POST (as you said get_site_title is POST)
  getSiteTitle: () => apiPostFormRoot("/get_site_title", "v6", {}),

  getOperationsWithMaster: (from_date, to_date, device_id = "") =>
    apiPostForm("/get_operations_with_master", {
      from_date,
      to_date,
      device_id,
    }),

  // CO Dashboard (example API you mentioned earlier)
  getHourlyDeviceCount: (line_no, date) =>
    apiPostForm("/get_hourly_device_count", { line_no, date }),

  // ✅ GET /get_lines
  getLines: () => apiGet("/get_lines"),

  // ✅ GET /get_tls_operations
  getOperations: () => apiGet("/get_tls_operations"),

  // ✅ POST /get_master_operations_count
  getMasterOperationsCount: (line_no, op_id = "", date = "") =>
    apiPostForm("/get_master_operations_count", { line_no, op_id, date }),

  // ✅ POST /get_hourly_device_count
  getHourlyDeviceCount: (line_no, date = "") =>
    apiPostForm("/get_hourly_device_count", { line_no, date }),

  // =========================
  // NEW APIV8 APIs
  // =========================
  listCriticalDevices: () =>
    apiGetRoot("/list_critical_devices", "v8"),

  addCriticalDevice: (device_id) =>
    apiPostFormRoot("/add_critical_device", "v8", { device_id }),

  updateCriticalDevice: (d_id, device_id) =>
    apiPostFormRoot("/update_critical_device", "v8", { d_id, device_id }),

  deleteCriticalDevice: (d_id) =>
    apiPostFormRoot("/delete_critical_device", "v8", { d_id }),

  // ✅ operator dropdown
  listStaffUsersDept3: () =>
    apiGetRoot("/list_staff_users_dept3", "v8"),



  // ✅ get all
  getCriticalOperations: () =>
    apiGetRoot("/list_critical_operations", "v8"),

  // ✅ add
  addCriticalOperation: (data) =>
    apiPostFormRoot("/add_critical_operation", "v8", {
      line_no: data.line_no,
      op_id: data.op_id,
      device_id: data.device_id,
      target_pcs: data.target_pcs,
      count_pcs: data.count_pcs,
      operator_id: data.operator_id,
      order_no: data.order_no,
    }),

  // ✅ edit
  updateCriticalOperation: (com_id, data) =>
    apiPostFormRoot("/edit_critical_operation", "v8", {
      com_id,
      line_no: data.line_no,
      op_id: data.op_id,
      device_id: data.device_id,
      target_pcs: data.target_pcs,
      count_pcs: data.count_pcs,
      operator_id: data.operator_id,
      order_no: data.order_no,
      status: data.status,
    }),

  // ✅ delete
  deleteCriticalOperation: (com_id) =>
    apiPostFormRoot("/delete_critical_operation", "v8", { com_id }),


  getIncentiveLineReport: (
  line_no = "",
  page = 1,
  limit = 10
) =>
  apiPostFormRoot("/incentive_line_report", "v8", {
    line_no,
    page,
    limit,
  }),
};

export default CriticalOperationService;